import Vue from 'vue'
import Login from './login.vue'
import initGlobalState from '../../common/utils/initGlobalState.util'
    // import CookieParser from '../../common/classes/CookieParser'

    //Vue.config.productionTip = false

    ; (async () => {

        // if (localStorage.getItem('userInfo') === null)
        //     localStorage.setItem("userInfo",'{"username":"localmachine","email":"localmachine@travelfactory.fr","roles":["ROLE_ADMIN","ROLE_DEV"],"lastLogin":1677081879183}');
        // if (CookieParser.cookies.company=== null)
        //     CookieParser.setCookies({ company: "cgos" });
        // if (CookieParser.cookies.website=== null)
        //     CookieParser.setCookies({ website: "fr-FR-CSE" });    

        await initGlobalState()
        new Vue({
            render: (createElement) => createElement(Login)
        }).$mount('#app')
    })()
